import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectForumPostsQueryItems } from '../../../../../redux/forum-posts/selector';
import { selectForumTopicsListItems} from '../../../../../redux/forum-topics/selector';
import { forumPosts } from '../../../../../redux/forum-posts/action';
import ForumPostComponent from '../components/forum-post.component';
import { forumTopics } from '../../../../../redux/forum-topics/action';

const AgencyForumPost = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const forumPostsQuery = useSelector(selectForumPostsQueryItems);
  const forumTopicsItems = useSelector(selectForumTopicsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedForumPosts, setSelectedForumPosts] = useState<any>({});

  const fetchForumPostsQueryById = () => {
    dispatch(forumPosts.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-posts/query`,
      entity: 'forumPosts',
      jsonData: {
        Records: [
          {
            
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedForumPosts({ ...selectedForumPosts, [field]: event });
  }


  useEffect(() => {
    dispatch(forumTopics.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/list`,
          entity: 'forumTopics',
          jsonData: {}
        })).then(() => {
            if (parmas?.id > 0) {
                fetchForumPostsQueryById()
              setIsLoading(false)
            } else {
              setIsLoading(false)
            }
          })
  }, []);

  useEffect(() => {
    if (isQuery) {
        setSelectedForumPosts(forumPostsQuery?.result?.items);
    }
  }, [isQuery]);


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(forumPosts.resetAction({ actionType: 'update' }))
      await dispatch(forumPosts.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-posts`,
        entity: 'forumPosts',
        jsonData: {
          Records: [
            selectedForumPosts
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(forumPosts.resetAction({ actionType: 'create' }))
      await dispatch(forumPosts.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-posts`,
        entity: 'forumPosts',
        jsonData: {
          Records: [
            selectedForumPosts
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/agencies/forum/forum-posts');
  }

  return (
    <>
      {forumPostsQuery?.isLoading ? <PageLoader /> :
        <ForumPostComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedForumPost={selectedForumPosts}
          back={back}
          handleFormSubmit={handleFormSubmit}
          forumTopics={forumTopicsItems?.result?.items}
        />
      }
    </>
  );
}

export default AgencyForumPost;
